import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import {
	type VereAgirFormData,
	vereAgirSchema,
} from '../../schemas/ver-e-agir-schema'

export function useVereAgirForm() {
	return useForm<VereAgirFormData, Record<string, never>, VereAgirFormData>({
		defaultValues: {
			date: '',
			customerClassificationId: '',
			kindId: '',
			riskId: '',
			potential: '',
			description: '',
			immediateAction: '',
			responsibleId: '',
			dueDate: '',
			status: '',
			situation: '',
			image: undefined,
		},
		resolver: zodResolver(vereAgirSchema),
		shouldFocusError: true,
		mode: 'onSubmit',
	})
}
